<template>
  <div class="news-detail">
    <div class="detail">
      <p class="title">{{newsDetail.title}}</p>
      <p class="tip">
        <span class="spa1">{{newsDetail.create_time | time_standard}}</span>
      </p>

      <p class="sumary">{{newsDetail.content_unsigned}}</p>

      <div class="news-imgs" v-if="newsDetail.file_arr && newsDetail.file_arr.length > 0">
        <img v-for="(item, index) in newsDetail.file_arr" :key="index" :src="$store.state.img_req_url + item.path">
      </div>
    </div>

    <Spin fix v-if="detailLoading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { wxShare } from '../service'
import { topicDetail } from '@/service'
import { get_meta } from 'js/get_meta'
import { share } from 'mobile/js/wx_share'
export default {
  metaInfo() {
    return {
      title: this.meta_title,
    }
  },
  mixins: [get_meta],
  data() {
    return {
      newsDetail: {},
      detailLoading: true,
      uid: this.$route.params.uid,
      meta_title: '动脉橙-数字健康产业信息服务商',
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
  },
  methods: {
    async getDetail() {
      let res = await topicDetail(
        { news_uid: this.$route.params.uid, user_key: this.user_key },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      this.detailLoading = false
      if (res.status == 'success') {
        this.$set(this.$data, 'newsDetail', res.res[0])
        this.meta_title = this.newsDetail.title + '-动脉橙'
        this.themeShare()
      } else {
        if (res.code == '10404') {
          this.$router.replace({ name: 'NoFound' })
        } else {
          this.$Message.error(res.message)
        }
      }
    },
    async themeShare() {
      let lurl = this.$store.state.index_path + '/mindex' + this.$route.fullPath
      let desc = this.newsDetail.content_unsigned.length == 50 ? this.newsDetail.content_unsigned + '...' : this.newsDetail.content_unsigned
      let res = await wxShare(
        { url: lurl },
        (error) => {
          this.$Message.error('请求错误!')
        }
      )
      share(
        res,
        {
          title: this.newsDetail.title + '-动脉橙',
          desc: desc,
          link: lurl,
          imgUrl: this.$store.state.static_img_url + '/favicon.ico'
        },
        this,
        window.location.href
      )
    },
  },
  created() {
    let arr = ['news_topic_type']
    this.getMeta(arr, this.getDetail)
  },
}
</script>

<style lang="stylus" scoped>
.news-detail
  padding 0.4rem
  background #ff8824
  min-height 100vh
  .detail
    padding 0.4rem
    background #fff
    border-radius 0.12rem
    min-height calc(100vh - 0.8rem)
    .title
      font-size 0.4rem
      font-weight bold
      color #333
      line-height 0.52rem
    .tip
      font-size 0.24rem
      color #666
      margin-top 0.4rem
      .spa2
        margin-left 0.2rem
      .tag
        color #ff8824
        margin-left 0.2rem
    .sumary
      font-size 0.32rem
      line-height 0.48rem
      margin-top 0.4rem
      color #333
    .news-imgs
      margin-top 0.4rem
      img
        width 100%
        &+img
          margin-top 0.4rem
  >>>.ivu-spin
    color #ff8824
</style>
